import { FC } from 'react';
import { Modal } from 'antd';

// Shared UI Library Components
import { CustomButton } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './activate-counsellor-stripe-modal.scss';

type TActivateCounsellorStripeModalProps = {
  open: boolean;
  onCancel?: () => void;
  onSubmit?: () => void;
}

export const ActivateCounsellorStripeModal: FC<TActivateCounsellorStripeModalProps> = (
  {
    open = false,
    onCancel = () => {},
    onSubmit = () => {}
  }: TActivateCounsellorStripeModalProps
) => {

  const handleCancel = (): void => {
    onCancel();
  };

  const handleSubmit = (): void => {
    onSubmit();
  };

  return (
    <Modal
      rootClassName="activate-counsellor-stripe-modal"
      width={ '394px' }
      open={ open }
      centered={ true }
      closeIcon={ null }
      title={ 'Consultations will be provided free of charge after the Consultant is activated.' }
      footer={ [
        <CustomButton key="ok" text={ 'Ok' } onClick={ handleSubmit }/>
      ] }
      onCancel={ handleCancel }
    >
      To activate paid consultations, first connect your Stripe account and then change the Pricing Settings.
    </Modal>
  )
};
